const PaymentButtonType = {
	SUBSCRIBE: 'subscribe', // Subscribe or Renew
	EDIT_PAYMENT_METHOD: 'edit_payment_method', // Trigger checkout flow to only edit payment method of current subscription
} as const;

export default PaymentButtonType;
